module.exports = __webpack_public_path__ + "img/location-map-updated.29c075c9.jpg";